var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-4 text-center",style:(_vm.styles)},[_c('beat-loader',{attrs:{"color":_vm.style.colorPrimary}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }